import { useMutation } from 'react-query'
import { AxiosError } from 'axios'
import { repairStatementPaidInvoices, StatementRepairResult } from './statementRepairApi'

export const useStatementRepairMutation = () => {
  return useMutation<StatementRepairResult, AxiosError, void>({
    mutationFn: () => repairStatementPaidInvoices(),
  })
}
